
import { Plane, Car, Calendar, Users, Building2 } from 'lucide-react';

const SERVICES = [
  {
    id: '1',
    title: 'Airport Transfers',
    slug: 'airport-transfers',
    short_description: 'Reliable and comfortable airport transportation services with flight tracking',
    icon: 'Plane',
  },
  {
    id: '2',
    title: 'Corporate Travel',
    slug: 'corporate-travel',
    short_description: 'Professional transportation solutions for business needs and executive travel',
    icon: 'Building2',
  },
  {
    id: '3',
    title: 'Hourly Service',
    slug: 'hourly-service',
    short_description: 'Flexible chauffeur service available by the hour for your convenience',
    icon: 'Car',
  },
  {
    id: '4',
    title: 'Special Events',
    slug: 'special-events',
    short_description: 'Luxury transportation for weddings, parties, and special occasions',
    icon: 'Calendar',
  },
  {
    id: '5',
    title: 'Group Transportation',
    slug: 'group-transportation',
    short_description: 'Comfortable group travel solutions for any size party',
    icon: 'Users',
  },
];

const icons = {
  Plane,
  Car,
  Calendar,
  Users,
  Building2,
};

const ServicesPage = () => {
  const services = SERVICES;
  const isLoading = false;

  return (
    <div className="min-h-screen bg-white">
      <div className="bg-gradient-to-r from-secondary to-secondary-dark text-white py-24">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-6 animate-fade-in">Our Services</h1>
          <p className="text-xl text-gray-200 max-w-2xl animate-fade-in-up">
            Experience luxury transportation tailored to your needs. From airport transfers to special events,
            we provide professional and reliable service for every occasion.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        {isLoading ? (
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services?.map((service) => {
              const IconComponent = icons[service.icon as keyof typeof icons] || Car;
              return (
                <div
                  key={service.id}
                  className="group bg-white rounded-xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
                >
                  <div className="flex flex-col items-center text-center space-y-4">
                    <div className="bg-primary/10 p-4 rounded-full group-hover:bg-primary/20 transition-colors">
                      <IconComponent className="w-12 h-12 text-primary" />
                    </div>
                    <h3 className="text-2xl font-semibold text-gray-900">{service.title}</h3>
                    <p className="text-gray-600">{service.short_description}</p>
                    <div className="h-px w-16 bg-primary/30 my-4"></div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="mt-20 bg-gray-50 rounded-2xl p-12">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
            Why Choose Our Services?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="p-6 text-center">
              <div className="text-2xl font-bold text-primary mb-2">24/7</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Always Available</h3>
              <p className="text-gray-600">Round-the-clock service to meet your transportation needs</p>
            </div>
            <div className="p-6 text-center">
              <div className="text-2xl font-bold text-primary mb-2">100%</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Satisfaction</h3>
              <p className="text-gray-600">Committed to exceeding your expectations</p>
            </div>
            <div className="p-6 text-center">
              <div className="text-2xl font-bold text-primary mb-2">15+</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Years Experience</h3>
              <p className="text-gray-600">Professional and experienced chauffeurs</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
